import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';


import Homepage from './pages/Homepage';
import Aboutpage from './pages/Aboutpage';
import Howworkspage from './pages/Howworkspage';
import Contactpage from './pages/Contactpage';
import Pricingpage from './pages/Pricingpage';
import Privacypage from './pages/Privacypage';
import Termspage from './pages/Termspage';




// ScrollToTop
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// GAHandler


const App = () => {


  return (
    <>
      <ScrollToTop />




      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<Aboutpage />} />
        <Route path="/how-it-works" element={<Howworkspage />} />
        <Route path="/contact" element={<Contactpage />} />

         <Route path="/Pricing" element={<Pricingpage />} />


          <Route path="/privacy" element={<Privacypage />} />
           <Route path="/terms" element={<Termspage />} />



      </Routes>
    </>
  );
};

export default App;